import { render, staticRenderFns } from "./YitzhakRabinArticle.vue?vue&type=template&id=e9f335de&"
import script from "./YitzhakRabinArticle.vue?vue&type=script&lang=js&"
export * from "./YitzhakRabinArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports